import { render, staticRenderFns } from "./NotificationsComponent.vue?vue&type=template&id=4b31b15d&scoped=true&"
import script from "./NotificationsComponent.vue?vue&type=script&lang=js&"
export * from "./NotificationsComponent.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsComponent.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./NotificationsComponent.vue?vue&type=style&index=1&id=4b31b15d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b31b15d",
  null
  
)

export default component.exports